import { ComponentProps } from 'react';

const BordRightToLeftListBulletIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="none" viewBox="0 0 9 8">
      <path d="M0.375 0.5L6.375 0.500001" stroke={stroke || '#141b34'} strokeWidth="0.75" strokeLinecap="round" />
      <path d="M8.375 0.5H8.37949" stroke={stroke || '#141b34'} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.375 4H8.37949" stroke={stroke || '#141b34'} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.375 7.5H8.37949" stroke={stroke || '#141b34'} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.375 4L6.375 4" stroke={stroke || '#141b34'} strokeWidth="0.75" strokeLinecap="round" />
      <path d="M0.375 7.5L6.375 7.5" stroke={stroke || '#141b34'} strokeWidth="0.75" strokeLinecap="round" />
    </svg>
  );
};

export default BordRightToLeftListBulletIcon;
